import Topic from '@/api/topic';
import EntityView from '@/views/EntityView.vue';

export const TOPIC_ROUTE = [
  {
    path: `/${Topic.SLUG}/`,
    name: `${Topic.SLUG}-list`,
    component: EntityView,
    props: () => ({
      entity: Topic.SLUG
    }),

    meta: {
      title: 'Topics · ELSA Content Creator'
    }
  },
  {
    path: `/${Topic.SLUG}/new`,
    name: `${Topic.SLUG}-new`,
    component: EntityView,
    props: () => ({
      entity: Topic.SLUG,
      isNew: true,
      isEdit: true
    }),

    meta: {
      title: 'New Topic · ELSA Content Creator'
    }
  },
  {
    path: `/${Topic.SLUG}/:id(\\d+)`,
    name: `${Topic.SLUG}-edit`,
    component: EntityView,
    props: (route) => ({
      entity: Topic.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Topic · ELSA Content Creator'
    }
  }
];
